import gql from 'graphql-tag';

export default gql`
  fragment groupActivityFragment on GroupActivityType {
    id
    groupId
    userId
    title
  }
`;
